export type WheelsVehicleTypeId = string;

export interface WheelsVehicleType {
  id: WheelsVehicleTypeId;
  name: string;
}

export enum WheelsVehicle {
  Sedan = 'SEDAN',
  Suv = 'SUV',
  Transit = 'TRANSIT',
}

const WHEELS_VEHICLE_CAPACITY: Record<WheelsVehicle, { min: number; max: number }> = {
  [WheelsVehicle.Sedan]: { min: 1, max: 4 },
  [WheelsVehicle.Suv]: { min: 1, max: 6 },
  [WheelsVehicle.Transit]: { min: 1, max: 10 },
};

export const getWheelsVehicleCapacity = (vehicle: WheelsVehicle) => WHEELS_VEHICLE_CAPACITY[vehicle];
